module.exports = __webpack_public_path__ + "static/Jordan_Miller_Resume_Feb-2022-61cffffce0998bbbf61928f1b6d01bfd.pdf";